import React from "react";
import MenuItemTable from "./MenuItemTable";
import { useQuery } from "react-query";
import apiService from "services/api";

const MenuItemPage = () => {
    const {
        data: menuItems,
        isLoading,
        refetch,
    } = useQuery("menuItem", () => apiService.getMenuItems());

    return (
        <div className="content">
            {!isLoading && <MenuItemTable data={menuItems} refetch={refetch} />}
        </div>
    );
};

export default MenuItemPage;
